import React, { useContext } from 'react';
import HeaderDesktop from 'src/components/layout/redesign/header-desktop';
import { amplitudeTrackEvent } from 'src/helpers/amplitude-event-track';
import { SiteContext } from 'src/context/site-context';
import { CmsContent } from 'src/content';
import PromoRibbon from 'src/components/layout/redesign/header-shared/promo-ribbon';
import { useHeaderPromoRibbonContent } from 'src/components/layout/redesign/club-header-desktop/use-header-promo-ribbon-content';

const ClubHeaderDesktop = () => {
  const { headerContent } = useContext(CmsContent);
  const { pageLevel } = useContext(SiteContext);

  const promoRibbonContent = useHeaderPromoRibbonContent();

  return (
    <HeaderDesktop
      headerContent={headerContent}
      primaryButton={
        headerContent?.headerButtonPrimary
          ? {
              type: 'link',
              buttonProps: headerContent.headerButtonPrimary,
              handleClick: () => {
                amplitudeTrackEvent(`Click to ${headerContent.headerButtonPrimary?.buttonText}`, {
                  custom_page: window.location.origin,
                  custom_level: pageLevel,
                });
              },
            }
          : undefined
      }
      secondaryButton={
        headerContent?.headerButtonSecondary
          ? {
              type: 'link',
              buttonProps: headerContent.headerButtonSecondary,
              handleClick: () => {
                amplitudeTrackEvent(`Click to ${headerContent.headerButtonSecondary?.buttonText}`, {
                  custom_page: window.location.origin,
                  custom_level: pageLevel,
                });
              },
            }
          : undefined
      }
      ribbonChildren={promoRibbonContent && <PromoRibbon promoRibbon={promoRibbonContent} />}
    />
  );
};

export default ClubHeaderDesktop;
